export default __webpack_public_path__ + "static/Toyota Certified – Vertical 400x400-72ec6e2a0d9df195ee142ca0a7b9b7ed.svg";